import type { HTMLAttributes } from 'react';
import { cn } from '@/utils/cn';

export function Container({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('mx-auto w-full max-w-6xl px-4 py-8 sm:px-6', className)} {...rest} />;
}
